<template>
  <div id="support-page-containter" class="noto-sans-sc-font-family">
    <!-- <div id="support-title" class="text-center py-3 text-uppercase">{{ supportSubject }}</div> -->
    <!-- <div id="support-subjects-container">
      <div
        id="support-subjects-list"
        class="main-content-width mx-auto text-uppercase d-flex justify-center flex-wrap"
      >
        <router-link :to="subject.url" v-for="(subject, index) in supportSubjects" :key="index">
          <div
            class="support-subject-title support-subject-animate-button font-size-12 py-3 text-center text-uppercase mx-2"
          >{{ subject.name }}</div>
        </router-link>
      </div>
    </div> -->
    <div id="support-content-container" class="main-content-width mx-auto">
      <transition name="fade-transform" mode="out-in">
        <div v-if="isRequestSubmitted" class="text-center customer-service-message-container">
          <div class="icon-sprite request-submitted-sprite mx-auto"></div>
          <div class="mt-4">{{requestSubmittedMessage}}</div>
          <v-btn
            color="#e2211c"
            text
            width="155px"
            class="mt-4"
            @click="dismissCSMessageBox"
          >close x</v-btn>
        </div>
        <div class="text-center customer-service-message-container" v-else-if="isRequestFailed">
          <div class="icon-sprite request-failed-sprite mx-auto"></div>
          <div class="mt-4">{{requestSubmittedMessage}}</div>
          <v-btn
            color="#e2211c"
            text
            width="155px"
            class="mt-4"
            @click="dismissCSMessageBox"
          >close x</v-btn>
        </div>
        <keep-alive v-else>
          <router-view
            @onContentDownloading="onContentDownloadStatusChange"
            @onContentDownloaded="onContentDownloadStatusChange"
            @onCustomerServiceRequestSubmitted="onCustomerServiceRequestSubmitted"
            @onCustomerServiceRequestFailed="onCustomerServiceRequestFailed"
          ></router-view>
        </keep-alive>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    loading: true,
    isRequestSubmitted: false,
    isRequestFailed: false,
    requestSubmittedMessage: ""
  }),

  methods: {
    onContentDownloadStatusChange(isloading) {
      this.loading = isloading;
    },

    onCustomerServiceRequestSubmitted(isRequestSubmitted, meesage) {
      this.isRequestSubmitted = isRequestSubmitted;
      this.requestSubmittedMessage = meesage;
      window.scrollTo(0, 0);
    },

    onCustomerServiceRequestFailed(isRequestFailed, message) {
      this.isRequestFailed = isRequestFailed;
      this.requestSubmittedMessage = message;
    },

    dismissCSMessageBox() {
      this.isRequestSubmitted = false;
      this.isRequestFailed = false;
      this.requestSubmittedMessage = "";
    }
  },

  computed: {
    supportSubject() {
      return this.$route.meta.title;
    },
    supportSubjects() {
      if (this.$route.meta.title == "Customer Service") {
        return [
          {
            name: "contact us",
            url: "/support/contact_us"
          },
          {
            name: "faq",
            url: "/support/faq"
          },
          {
            name: "warranty",
            url: "/support/warranty_register"
          },
          {
            name: "refund & exchange",
            url: "/support/refund_exchange"
          }
        ];
      } else {
        return [
          {
            name: "about us",
            url: "/support/about_us"
          },
          {
            name: "warranty",
            url: "/support/warranty"
          },
          {
            name: "term of use",
            url: "/support/terms_condition"
          },
          {
            name: "privacy policy",
            url: "/support/privacy_policy"
          }
        ];
      }
    }
  }
};
</script>

<style scoped>
.main-content-width {
  max-width: 1000px;
}

#support-title {
  border-bottom: 1px solid #e6e6e6;
  border-top: 1px solid #e6e6e6;
  color: #333333;
  font-size: 24px;
}

.support-subject-title {
  transition: 0.6s;
  color: #999999;
  width: 140px;
}

.router-link-active > .support-subject-title {
  color: white;
  background-color: #e2211c;
}

#support-content-container {
  /* padding: 30px 50px 50px 50px; */
  color: #333333;
}

@media only screen and (max-width: 500px) {
  #support-content-container {
    /* padding: 20px; */
  }
}

.support-subject-animate-button {
  background-image: linear-gradient(#e2211c, #e2211c);
  background-repeat: no-repeat;
  background-position: 50% 0%;
  background-size: 100% 0%;
  transition: background-size 0.8s;
}

.support-subject-animate-button:hover {
  background-image: linear-gradient(#e2211c, #e2211c);
  color: white;
  background-size: 100% 100%;
}

.request-submitted-sprite {
  height: 155px;
  width: 155px;
  background-position: 0px -72px;
}

.request-failed-sprite {
  height: 155px;
  width: 155px;
  background-position: -184px -72px;
}

.customer-service-message-container {
  margin-top: 30px;
}
</style>>


